
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cgu",
      function () {
        return require("private-next-pages/cgu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cgu"])
      });
    }
  